module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base-module/components/file-upload-box/file-upload-box.component.scss
// module id = ./src/app/modules/base-module/components/file-upload-box/file-upload-box.component.scss
// module chunks = 9